export const CATS_CUSTOMER_CONTROLLER_ROOT_PATH = "/customer";

export const CATS_CUSTOMER_GET_ALL_PATH_SUFFIX = "/cats";
/** /customer/cats */
export const CATS_CUSTOMER_GET_ALL_PATH = CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_GET_ALL_PATH_SUFFIX;

export const CATS_CUSTOMER_SHOW_PATH_SUFFIX = "/cat/show";

export const CATS_CUSTOMER_UPDATE_DETAILS_PATH_SUFFIX = "/cat/update";
/** /customer/cat/update */
export const CATS_CUSTOMER_UPDATE_DETAILS_PATH =
  CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_UPDATE_DETAILS_PATH_SUFFIX;

export const CATS_CUSTOMER_GET_ONE_PATH_PARAM = "catId";
export const CATS_CUSTOMER_GET_ONE_SUFFIX =
  `${CATS_CUSTOMER_SHOW_PATH_SUFFIX}/:${CATS_CUSTOMER_GET_ONE_PATH_PARAM}`;
/** /customer/cat/show/:catId */
export const CATS_CUSTOMER_GET_ONE_PATH =
  CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_GET_ONE_SUFFIX;

export const CATS_CUSTOMER_CREATE_PATH_SUFFIX = "/cat/create";
/** /customer/cat/create */
export const CATS_CUSTOMER_CREATE_PATH = CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_CREATE_PATH_SUFFIX;
